export default "__VITE_ASSET__Dp6Dx5TG__"